import { VideoQuality } from '@zoom/videosdk';
import { useCallback, useState } from 'react';

function useVisualBackground({ mediaStream, userId, selfVideoContainerId }) {
  const [isBlur, setIsBlur] = useState(false);

  const toggleBlur = useCallback(
    async blur => {
      const videoElement = document.getElementById(selfVideoContainerId);
      let params = {};
      if (blur) {
        params = {
          virtualBackground: { imageUrl: 'blur' },
        };
      } else {
        params = {};
      }
      setIsBlur(blur);
      await mediaStream.stopVideo();
      await mediaStream.detachVideo(userId);
      await mediaStream.startVideo(params);
      await mediaStream.attachVideo(userId, VideoQuality.Video_360P).then(video => {
        videoElement.innerHTML = '';
        videoElement.appendChild(video);
      });
    },
    [selfVideoContainerId, mediaStream, userId],
  );

  const changeBackground = useCallback(
    async src => {
      const videoElement = document.getElementById(selfVideoContainerId);
      let params = {};
      params = {
        virtualBackground: { imageUrl: src },
      };
      await mediaStream.stopVideo();
      await mediaStream.detachVideo(userId);
      await mediaStream.startVideo(params);
      await mediaStream.attachVideo(userId, VideoQuality.Video_360P).then(video => {
        videoElement.innerHTML = '';
        videoElement.appendChild(video);
      });
    },
    [selfVideoContainerId, mediaStream, userId],
  );

  return { isBlur, toggleBlur, changeBackground };
}

export default useVisualBackground;
